import React from 'react'

export const IconMessage2: React.FC = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20">
      <path
        fill="#122B46"
        fillOpacity="0.5"
        d="M10 0C4.486 0 0 4.486 0 10c0 1.638.431 3.167 1.13 4.532L.048 18.414c-.253.902.639 1.792 1.54 1.54l3.885-1.084C6.836 19.57 8.363 20 10 20c5.514 0 10-4.486 10-10S15.514 0 10 0m0 1.5c4.703 0 8.5 3.797 8.5 8.5s-3.797 8.5-8.5 8.5a8.44 8.44 0 0 1-4.128-1.073.75.75 0 0 0-.567-.068L1.61 18.391l1.032-3.692a.75.75 0 0 0-.068-.567A8.45 8.45 0 0 1 1.5 10c0-4.703 3.797-8.5 8.5-8.5"
      ></path>
    </svg>
  )
}
